import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { EventsState } from '../../../../../store/types';
import { ColorKeys, PageModule, TextOverrides } from '../../../../../types/working-model';
import { GetDefaultQuestion } from '../../../../../store/utils/create-event';
import './questions.scss';
import { TemplateClassNames } from '../../../../../types/template-layouts';
import { useParams } from 'react-router';
import { ParamsProps } from '../../../../live-event/live-event';
import { getTextValue, updateTranslateKey } from '../../../../../utils/utils';
import { EContentColorOverrideNames } from './moduleControls/edit-section-colors-modal';
import EditableTextSlim from '../../../../general-ui/editable-text/editable-text-slim';
import { updatePageModule } from '../../../../../store/actions/admin/create-event/session';
import '../../../../live-event/session/session-modules/questions/questions.scss';
import InputSubmit from '../../../../live-event/session/session-modules/questions/input-submit';
import classNames from 'classnames';
import { getStylingOverrides } from '../../../../live-event/utils';
import Controls from '../session-module-controls/controls';

interface Props {
	page_module: PageModule;
	template: TemplateClassNames;
}

export default function Questions(props: Props): JSX.Element | null {
	const { page_module, template } = props;
	const {
		workingSession,
	} = useSelector((state: EventsState) => state.CreateSessionReducer);
	const { language } = useParams() as ParamsProps;
	const { t } = useTranslation('session');
	const dispatch = useDispatch();

	const content = page_module?.content || GetDefaultQuestion();
	const stylingOverrides = page_module?.styling_overrides;
	const { backgroundColor, backgroundImg } = getStylingOverrides(stylingOverrides);

	function handleTextChange(key: string) {
		return (text: string) => {
			if (!workingSession) return;
			dispatch(
				updatePageModule({
					...page_module,
					content: {
						...content,
						[key]: updateTranslateKey({
							translateString: page_module?.content?.[key],
							input: text,
							baseLanguage: workingSession.default_language,
							language
						})
					}
				})
			);
		};
	}
	function handleStyleOverrideChange(key: string) {
		return (overrides: TextOverrides) => {
			const updatedOverrides = {
				...stylingOverrides,
				content: {
					...stylingOverrides?.content,
					[key]: overrides
				}
			};
			dispatch(
				updatePageModule({
					...page_module,
					styling_overrides: updatedOverrides
				})
			);
		};
	}

	const { custom_heading } = getTextValue(content, language);

	return (page_module.is_on && (!workingSession?.layout?.withMenu || page_module)) ? (
		<div className={classNames(
			"editor-wrapper questions",
			backgroundColor,
			template
		)}
			style={backgroundImg}
		>
			<Controls
				page_module={page_module}
				openEditModal={() => ({})}
				display={{ editColors: true, changeSectionPosition: true }}
			/>
			<div className="container" >
				<EditableTextSlim
					tagType="p"
					className="questions-title"
					value={custom_heading}
					defaultColor={ColorKeys.bodyTextColor}
					onChange={handleTextChange('custom_heading')}
					onOverrideChange={handleStyleOverrideChange('custom_heading')}
					elementName={EContentColorOverrideNames.custom_heading}
					colorOverride={stylingOverrides?.content?.custom_heading?.color}
				/>
				<div className="questions-content">
					{/* <p>{t('questions.No questions yet')}</p> */}
					<InputSubmit
						module={page_module}
						placeholder={t("What is on your mind")}
						buttonText={t("Ask question")}
						onSubmitClick={() => { return Promise.resolve({}); }}
					/>
				</div>
			</div>
		</div>
	) : null;
}